export function logVirtualPageView(title) {
  window.dataLayer.push({
    event: "virtualPageView",
    pageUrl: document.location.href,
    pageTitle: title
  });
}
